/**
 * This function returns props for the button itself i.e. Button, LoadingButton, etc.
 * The props returned are used to configure the button size and block variant
 */
export function getButtonVariantProps({
  variant
}) {
  let size;
  const margin = '0';
  switch (variant) {
    case 'block':
      {
        size = 'medium';
        break;
      }
    case 'table-header':
      {
        size = 'medium';
        break;
      }
    default:
      break;
  }
  return {
    block: true,
    size,
    margin
  };
}

/**
 * This function returns props for the Flex and View components that wrap around buttons.
 * The props returned are used to configure the size, width, etc of the wrapper.
 * The button itself is block, so it will always fill the width of the wrapper.
 */
export function getTrellisButtonVariantProps({
  variant,
  visible = true
}) {
  let inlineSize;
  let maxInlineSize;
  let marginInline;
  switch (variant) {
    case 'block':
      {
        inlineSize = '100%';
        break;
      }
    case 'table-header':
      {
        inlineSize = '174px';
        maxInlineSize = '100%';
        marginInline = 'auto';
        break;
      }
    default:
      break;
  }
  return {
    // not trellis specific, but used for wrapper around foundations-components
    visible,
    // for trellis primitives/wrappers, i.e. Flex, View, etc
    inlineSize,
    maxInlineSize,
    marginInline
  };
}